import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { handleChange, handleSubmit } from "../../controller/UnitOfMeasureController/CreateUnitOfMeasure";
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";

function CreateContractRates({ unit, onClose, onSuccess }) {

    const { t } = useTranslation();
    const [formData, setFormData] = useState({ Measurment: '', DecimalPlaces: '' });
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme == "dark") {
        accordTheme = "accordion-header-dark";
    }

    useEffect(() => {
        if (unit) {
            setFormData({ Measurment: unit.Measurment, DecimalPlaces: unit.DecimalPlaces });
        } else {
            setFormData({ Measurment: '', DecimalPlaces: '' }); // Clear form data when switching to add mode
        }
    }, [unit]);

    const handleFieldChange = (event) => {
        handleChange(event, formData, setFormData);
    };

    const handleFormSubmit = (event) => {

        event.preventDefault(); // Prevent default form submission
        if (unit) {
            formData.ID = unit.ID;
        } else {
            formData.ID = 0;
        }
        const redirectCallback = () => {
            navigate('/'); // Redirect to the login page
        };
        const redirectUserList = () => {
            navigate('/AdministrationSetting?saved=true');
        };
        handleSubmit(event, formData, setFormData, setErrors, () => {

            if (unit) {
                formData.ID = unit.ID;
            } else {
                formData.ID = 0;
            }

            redirectCallback();
            onSuccess(); // Call onSuccess to reload data
            onClose(); // Close the modal on successful form submission
        }, () => {
            redirectUserList();
            onSuccess(); // Call onSuccess to reload data
            onClose(); // Close the modal on successful form submission
        });
    };

    return (
        <div>
            <form onSubmit={handleFormSubmit}>
                <div className="modal fade" id="UnitOfMeasuresModal" tabIndex="-1" aria-labelledby="UnitOfMeasuresModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className={`modal-header ${accordTheme}`}>
                                <h5 className="modal-title" id="largeModalLabel">{unit ? "Edit Unit of Measure" : "Add Unit of Measure"}</h5>
                                <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px", "marginTop": "10px" }}>
                                    <label htmlFor="inputText" className="col-sm-2 col-form-label">Measurment:</label>
                                    <div className="col-sm-4">
                                        <input type="text" className="form-control" name="Measurment" value={formData.Measurment} onChange={handleFieldChange} />
                                        {errors.Measurment && <div style={{ color: 'red' }}>{errors.Measurment}</div>}
                                    </div>
                                    <label htmlFor="inputText" className="col-sm-2 col-form-label">Decimal Places:</label>
                                    <div className="col-sm-4">
                                        <input type="text" className="form-control" name="DecimalPlaces" value={formData.DecimalPlaces} onChange={handleFieldChange} />
                                        {errors.DecimalPlaces && <div style={{ color: 'red' }}>{errors.DecimalPlaces}</div>}
                                    </div>
                                </div>


                            </div>
                            <div className="modal-footer">
                                <button type="submit" className="btn btn-primary">
                                    <i className="icofont-save" aria-hidden="true"> {unit ? " Update" : " Save"}</i>
                                </button>
                                <button className="btn btn-secondary" type="button" data-dismiss="modal" aria-label="Close">
                                    <i className="icofont-close" aria-hidden="true"> Close</i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>

        </div>
    );
}

export default CreateContractRates;